import * as React from 'react';
import dayjs from 'dayjs';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { Select } from '@lean-body/components/atoms';
import { getFormattedToHyphenFormat } from '@lean-body/src/util';
import { RequiredBadge } from '../atoms/required_badge';
const { useState } = React;
export const DateSelectForm = ({ containerClassObject, label, currentValue, required, hasValidationError, validationErrorMessage, setCurrentValue, }) => {
    const value = dayjs(currentValue);
    const [year, setYear] = useState(currentValue ? `${value.year()}` : '');
    const [month, setMonth] = useState(currentValue ? `${value.month() + 1}` : '');
    const [day, setDay] = useState(currentValue ? `${value.date()}` : '');
    const changeYear = (event) => {
        setYear(event.target.value);
        setDate(event.target.value, month, day);
    };
    const changeMonth = (event) => {
        setMonth(event.target.value);
        setDate(year, event.target.value, day);
    };
    const changeDay = (event) => {
        setDay(event.target.value);
        setDate(year, month, event.target.value);
    };
    const setDate = (y, m, d) => {
        if (y || m || d) {
            setCurrentValue(getFormattedToHyphenFormat(y, m, d));
        }
        else {
            setCurrentValue('');
        }
    };
    const yearsList = () => {
        const yearsList = [{ value: '', name: '　' }];
        const YearLower = 1900;
        for (let year = dayjs().year(); year >= YearLower; year--) {
            yearsList.push({ value: `${year}`, name: `${year}` });
        }
        return yearsList;
    };
    const monthList = () => {
        const monthList = [{ value: '', name: '　' }];
        for (let month = 1; month <= 12; month++) {
            monthList.push({ value: `${month}`, name: `${month}` });
        }
        return monthList;
    };
    const dayList = () => {
        const dayList = [{ value: '', name: '　' }];
        for (let day = 1; day <= 31; day++) {
            dayList.push({ value: `${day}`, name: `${day}` });
        }
        return dayList;
    };
    return (React.createElement("div", { className: css(containerClassObject) },
        label && (React.createElement("div", { className: css(styles.label) },
            label,
            required && React.createElement(RequiredBadge, null))),
        React.createElement("div", { className: css(styles.selectContainer) },
            React.createElement(Select, { selectOptions: yearsList(), defaultValue: `${year}`, containerClassObject: styles.select, onChange: changeYear, displayIcon: true, placeholder: "\u5E74", placeholderValue: "", hasValidationError: hasValidationError }),
            React.createElement(Select, { selectOptions: monthList(), defaultValue: `${month}`, containerClassObject: styles.select, onChange: changeMonth, displayIcon: true, placeholder: "\u6708", placeholderValue: "", hasValidationError: hasValidationError }),
            React.createElement(Select, { selectOptions: dayList(), defaultValue: `${day}`, containerClassObject: styles.select, onChange: changeDay, displayIcon: true, placeholder: "\u65E5", placeholderValue: "", hasValidationError: hasValidationError })),
        validationErrorMessage && React.createElement("div", { className: css(styles.validationErrorMessage) }, validationErrorMessage)));
};
const styles = StyleSheet.create({
    selectContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    },
    select: {
        width: 'calc((100% - 16px) / 3)',
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 14,
        color: Colors.GrayDarkest,
        marginBottom: 8,
    },
    validationErrorMessage: {
        marginTop: 4,
        color: Colors.Alert,
        fontSize: 12,
        fontWeight: 400,
        lineHeight: '160%',
        letterSpacing: 0.48,
    },
});
